import { render, staticRenderFns } from "./Shared-Edit-File.vue?vue&type=template&id=4c079c52&scoped=true&"
import script from "./Shared-Edit-File.vue?vue&type=script&lang=js&"
export * from "./Shared-Edit-File.vue?vue&type=script&lang=js&"
import style0 from "./Shared-Edit-File.vue?vue&type=style&index=0&id=4c079c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c079c52",
  null
  
)

export default component.exports